import { pageViewTypes } from "@constants/tracking";
import LatestIssuesCollectionRouteContainer from "@features/articles/containers/LatestIssuesCollectionRouteContainer";
import { issues } from "@features/articles/hooks/useArticles";
import type { Issue } from "@features/articles/types";
import useAnalytics from "@hooks/useAnalytics";
import { useLocalSearchParams } from "expo-router";

const IssueList = () => {
	const { id } = useLocalSearchParams<{ id: string }>();

	const issue = issues.find((issue: Issue) => issue.id === Number.parseInt(id));

	useAnalytics({
		type: pageViewTypes.detailIssue,
		id,
	});

	return <LatestIssuesCollectionRouteContainer issue={issue} />;
};

export default IssueList;
